import { createAction, props } from '@ngrx/store';
import { Lookup } from 'src/app/shared/models/lookup.model';
import {
    WfdAdditionalInfo,
    WfdFacilitySystemAdditionalInfo,
    WfdHotelDetails,
    WfdHotelDetailsPayload,
    WorkforceDisruptionPlacementFlightBookingInformation,
    WorkforceDisruptionPlacementInformation,
    WorkforceDisruptionPlacementNote,
    WorkforceDisruptionPlacementTravelDetails
} from 'src/app/workforce-disruption/shared/models/workforce-disruption.model';
import { PersonalProfessionalInfo } from 'src/app/shared/components/personal-professional-info/models/personal-professional-info.model';
export const getWdpCandidateProfile = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Candidate Profile');
export const getWdpCandidateProfileSuccess = createAction(
    '[WDP API] Get WDP Candidate Profile Success',
    props<{ candidateProfile: PersonalProfessionalInfo }>()
);
export const getWdpCandidateProfileFailure = createAction(
    '[WDP API] Get WDP Candidate Profile Failure',
    props<{ error: unknown }>()
);

export const getWdpPlacementInformation = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT] Get WDP Placement Information'
);
export const getWdpPlacementInformationSuccess = createAction(
    '[WDP API] Get WDP Placement Information Success',
    props<{ placementsInformation: WorkforceDisruptionPlacementInformation }>()
);
export const getWdpPlacementInformationFailure = createAction(
    '[WDP API] Get WDP Placemen Information Failure',
    props<{ error: unknown }>()
);

export const getWdpTravelDetails = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Travel Details');
export const getWdpTravelDetailsSuccess = createAction(
    '[WDP API] Get WDP Travel Details Success',
    props<{ travelDetails: WorkforceDisruptionPlacementTravelDetails }>()
);
export const getWdpTravelDetailsFailure = createAction(
    '[WDP API] Get WDP Travel Details Failure',
    props<{ error: unknown }>()
);

export const updateWdpTravelDetails = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT] Update WDP Travel Details',
    props<{ travelDetails: WorkforceDisruptionPlacementTravelDetails }>()
);
export const updateWdpTravelDetailsSuccess = createAction(
    '[WDP API] Update WDP Travel Details Success',
    props<{ travelDetails: WorkforceDisruptionPlacementTravelDetails }>()
);
export const updateWdpTravelDetailsFailure = createAction(
    '[WDP API] Update WDP Travel Details Failure',
    props<{ error: unknown }>()
);

export const getWdpFlightBookingInformation = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT] Get WDP Flight Booking Information'
);
export const getWdpFlightBookingInformationSuccess = createAction(
    '[WDP API] Get WDP Flight Booking Information Success',
    props<{ flightBookingInformation: WorkforceDisruptionPlacementFlightBookingInformation[] }>()
);
export const getWdpFlightBookingInformationFailure = createAction(
    '[WDP API] Get WDP Flight Booking Information Failure',
    props<{ error: unknown }>()
);

export const updateWdpFlightBookingInformation = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT] Update WDP Flight Booking Information',
    props<{ flightBookingInformation: WorkforceDisruptionPlacementFlightBookingInformation[] }>()
);
export const updateWdpFlightBookingInformationSuccess = createAction(
    '[WDP API] Update WDP Flight Booking Information Success',
    props<{ flightBookingInformation: WorkforceDisruptionPlacementFlightBookingInformation[] }>()
);
export const updateWdpFlightBookingInformationFailure = createAction(
    '[WDP API] Update WDP Flight Booking Information Failure',
    props<{ error: unknown }>()
);

export const getWdpNotes = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Notes', props<{ id: number }>());
export const getWdpNotesSuccess = createAction(
    '[WDP API] Get WDP Notes Success',
    props<{ notes: WorkforceDisruptionPlacementNote[] }>()
);
export const getWdpNotesFailure = createAction('[WDP API] Get WDP Notes Failure', props<{ error: unknown }>());

export const addWdpNote = createAction('[WDP CANDIDATE PROFILE COMPONENT] Add WDP Notes', props<{ note: String }>());
export const addWdpNoteSuccess = createAction('[WDP API] Add WDP Notes Success');
export const addWdpNoteFailure = createAction('[WDP API] Add WDP Notes Failure', props<{ error: unknown }>());

export const getWdpTravelStatuses = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Travel Statuses');
export const getWdpTravelStatusesSuccess = createAction(
    '[WDP API] Get WDP Travel Statuses Success',
    props<{ travelStatuses: Lookup[] }>()
);
export const getWdpTravelStatusesFailure = createAction(
    '[WDP API] Get WDP Travel Statuses Failure',
    props<{ error: unknown }>()
);

export const getWdpTravelPlanTypes = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Travel Plan Types');
export const getWdpTravelPlanTypesSuccess = createAction(
    '[WDP API] Get WDP Travel Plan Types Success',
    props<{ travelPlanTypes: Lookup[] }>()
);
export const getWdpTravelPlanTypesFailure = createAction(
    '[WDP API] Get WDP Travel Plan Types Failure',
    props<{ error: unknown }>()
);

export const getWdpGenderTypes = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP Gender Types');
export const getWdpGenderTypesSuccess = createAction(
    '[WDP API] Get WDP Gender Types Success',
    props<{ genderTypes: Lookup[] }>()
);
export const getWdpGenderTypesFailure = createAction(
    '[WDP API] Get WDP Gender Types Failure',
    props<{ error: unknown }>()
);

export const getWdpStateCodes = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WDP State Codes');
export const getWdpStateCodesSuccess = createAction(
    '[WDP API] Get WDP State Codes Success',
    props<{ stateCodes: Lookup[] }>()
);
export const getWdpStateCodesFailure = createAction(
    '[WDP API] Get WDP State Codes Failure',
    props<{ error: unknown }>()
);

export const getWfdHotelDetails = createAction('[WDP CANDIDATE PROFILE COMPONENT] Get WFD Hotel Details');
export const getWfdHotelDetailsSuccess = createAction(
    '[WDP API] Get WFD Hotel Details Success',
    props<{ hotelDetails: WfdHotelDetails }>()
);
export const getWfdHotelDetailsFailure = createAction(
    '[WDP API] Get WFD Hotel Details Failure',
    props<{ error: unknown }>()
);

export const updateWfdHotelDetails = createAction(
    '[WDP CANDIDATE PROFILE COMPONENT] Update WFD Hotel Details',
    props<{ hotelDetailsPayload: WfdHotelDetailsPayload }>()
);
export const updateWfdHotelDetailsSuccess = createAction(
    '[WDP API] Update WFD Hotel Details Success',
    props<{ hotelDetailsPayload: WfdHotelDetailsPayload }>()
);
export const updateWfdHotelDetailsFailure = createAction(
    '[WDP API] Update WFD Hotel Details Failure',
    props<{ error: any }>()
);

const getWfdAdditionalInfo = createAction('[WFD BOOKED CANDIDATES DETAIL PAGE] Get Additional Info Card');

const getWfdAdditionalInfoSuccess = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Get Additional Info Card - Success',
    props<{ additionalInfo: WfdAdditionalInfo[] }>()
);

const getWfdAdditionalInfoError = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Get Additional Info Card - Error',
    props<{ error: any }>()
);

const updateWfdAdditionalInfo = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Additional Info Card',
    props<{ changes: WfdAdditionalInfo[]; additionalInfo: WfdAdditionalInfo[] }>()
);

const updateWfdAdditionalInfoSuccess = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Additional Info Card - Success',
    props<{ additionalInfo: WfdAdditionalInfo[] }>()
);

const updateWfdAdditionalInfoError = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Additional Info Card - Error',
    props<{ error: any }>()
);

const getWfdFacilitySystemAdditionalInfo = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Get Facility System Additional Info Card'
);

const getWfdFacilitySystemAdditionalInfoSuccess = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Get Facility System Additional Info Card - Success',
    props<{ additionalInfo: WfdFacilitySystemAdditionalInfo[] }>()
);

const getWfdFacilitySystemAdditionalInfoError = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Get Facility System Additional Info Card - Error',
    props<{ error: any }>()
);

const updateWfdFacilitySystemAdditionalInfo = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Facility System Additional Info Card',
    props<{ changes: WfdFacilitySystemAdditionalInfo[]; additionalInfo: WfdFacilitySystemAdditionalInfo[] }>()
);

const updateWfdFacilitySystemAdditionalInfoSuccess = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Facility System Additional Info Card - Success',
    props<{ additionalInfo: WfdFacilitySystemAdditionalInfo[] }>()
);

const updateWfdFacilitySystemAdditionalInfoError = createAction(
    '[WFD BOOKED CANDIDATES DETAIL PAGE] Update Facility System Additional Info Card - Error',
    props<{ error: any }>()
);

export const bookedCandidateDetailsActions = {
    getWdpCandidateProfile,
    getWdpCandidateProfileSuccess,
    getWdpCandidateProfileFailure,
    getWdpPlacementInformation,
    getWdpPlacementInformationSuccess,
    getWdpPlacementInformationFailure,
    getWdpTravelDetails,
    getWdpTravelDetailsSuccess,
    getWdpTravelDetailsFailure,
    updateWdpTravelDetails,
    updateWdpTravelDetailsSuccess,
    updateWdpTravelDetailsFailure,
    getWdpFlightBookingInformation,
    getWdpFlightBookingInformationSuccess,
    getWdpFlightBookingInformationFailure,
    updateWdpFlightBookingInformation,
    updateWdpFlightBookingInformationSuccess,
    updateWdpFlightBookingInformationFailure,
    getWdpNotes,
    getWdpNotesSuccess,
    getWdpNotesFailure,
    addWdpNote,
    addWdpNoteSuccess,
    addWdpNoteFailure,
    getWdpTravelStatuses,
    getWdpTravelStatusesSuccess,
    getWdpTravelStatusesFailure,
    getWdpTravelPlanTypes,
    getWdpTravelPlanTypesSuccess,
    getWdpTravelPlanTypesFailure,
    getWdpGenderTypes,
    getWdpGenderTypesSuccess,
    getWdpGenderTypesFailure,
    getWdpStateCodes,
    getWdpStateCodesSuccess,
    getWdpStateCodesFailure,
    getWfdHotelDetails,
    getWfdHotelDetailsFailure,
    getWfdHotelDetailsSuccess,
    updateWfdHotelDetails,
    updateWfdHotelDetailsFailure,
    updateWfdHotelDetailsSuccess,
    getWfdAdditionalInfo,
    getWfdAdditionalInfoSuccess,
    getWfdAdditionalInfoError,
    updateWfdAdditionalInfo,
    updateWfdAdditionalInfoSuccess,
    updateWfdAdditionalInfoError,
    getWfdFacilitySystemAdditionalInfo,
    getWfdFacilitySystemAdditionalInfoSuccess,
    getWfdFacilitySystemAdditionalInfoError,
    updateWfdFacilitySystemAdditionalInfo,
    updateWfdFacilitySystemAdditionalInfoSuccess,
    updateWfdFacilitySystemAdditionalInfoError
};
